import { cn } from '@/lib/utils'
import { colors } from '@/lib/tokens'

function EmptyState({
  icon,
  title,
  description,
  action,
  variant = 'default',
  className,
}: {
  icon: React.ReactNode
  title: string
  description?: string
  action?: React.ReactNode
  variant?: 'default' | 'error'
  className?: string
}) {
  const isError = variant === 'error'
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center rounded-lg',
        isError ? 'py-20' : 'py-28',
        className,
      )}
      style={isError ? {
        background: colors.errorSubtle,
        border: `1px solid ${colors.errorBorder}`,
      } : {
        background: colors.bgBase,
        border: `1px solid ${colors.borderDefault}`,
      }}
    >
      {icon && <div className={isError ? 'mb-3' : 'mb-4'}>{icon}</div>}
      <p
        className={cn('font-semibold mb-1', isError ? 'text-sm' : 'text-[15px]')}
        style={{ color: colors.textPrimary }}
      >
        {title}
      </p>
      {description && (
        <p className="text-sm" style={{ color: colors.textMuted }}>
          {description}
        </p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}

export { EmptyState }
